module.exports = __webpack_public_path__ + "static/media/add_vid.e99c0c70.jpg";